import { useHistory } from 'react-router'
import { decodeStringToArray } from '../foo/converter';
import { useGlobalStore } from './stateManagement/globalZustand';
import { useEffect } from 'react';
import { _LIMIT_CHARS_URL_SHARE, _pathSeparator, _pathSeparatorPlaceholder } from './constants';
import { useURLStore } from './stateManagement/URLZustand';


const URLImport: React.FC= () => {
    const { URLVars, getURLTo } = useURLStore();
    const { setClipboardCards, setIsParentMode } = useGlobalStore();
    const history = useHistory();

    
    useEffect(() => {
        if(URLVars.labels === undefined){ return;}
        if(URLVars.labels && URLVars.labels.length > _LIMIT_CHARS_URL_SHARE){ return;}
        setClipboardCards(URLVars.labels!.split(_pathSeparator));
        //setClipboardCards(decodeStringToArray(URLVars.labels!).map(s => s.replaceAll(_pathSeparatorPlaceholder, _pathSeparator)));
        setIsParentMode(true);
        history.push(getURLTo().home());
    }, [URLVars.labels])

    
    return <></>
}

export default URLImport